import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'my-12 last-of-type:mb-0',
    imageContainer: 'relative max-sm:mx-[-12px] max-sm:w-[calc(100%+24px)]',
    imageInner: 'relative w-full',
    image: 'object-cover',
    imageAlt: 'heading-xs text-secondary-hover mt-4 italic',
    text: 'prose-headings:scroll-mt-[calc(var(--head-fixed-height)+24px)] sm:prose-h2:heading-2xl-desk prose-h2:heading-2xl sm:prose-h3:heading-2xl prose-h3:heading-m-bold sm:prose-h2:mb-6 prose-h2:mb-4 sm:prose-h3:mb-6 prose-h3:my-4 prose-p:my-4 prose-p:last-of-type:mb-0 prose-p:first-of-type:mt-0 prose-blog max-sm:prose-blog-sm',
    products: 'mb-152max-sm:mt-8 mt-12 max-sm:mb-8',
    carousel:
      '[--slide-size:212px] [--slide-spacing:20px] sm:[--slide-size:calc(100%/2)] md:[--slide-size:calc(100%/3)]',
    arrowPrev: 'top-[150px]',
    arrowNext: 'top-[150px]'
  },
  variants: {
    position: {
      top: {
        imageContainer: 'my-12 w-full',
        imageInner: 'h-[360px]'
      },
      bottom: {
        imageContainer: 'my-12 w-full',
        imageInner: 'h-[360px]'
      },
      left: {
        imageContainer:
          'float-left mr-10 mb-4 aspect-square w-[360px] max-xl:w-[300px] max-sm:float-none max-sm:my-10'
      },
      right: {
        imageContainer:
          'float-right mb-4 ml-10 aspect-square w-[360px] max-xl:w-[300px] max-sm:float-none max-sm:my-10'
      }
    }
  },
  defaultVariants: {
    position: 'top'
  }
});
